import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "../../components/misc/Card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../components/misc/Table";
import Spinner from "../../components/misc/Spinner";
import { WeeklySummaryRun } from "./types";

interface RunsTableProps {
    runs: WeeklySummaryRun[];
    loading: boolean;
}

const periodLabel = (key: string): string => `${key.slice(0, 4)}-${key.slice(4, 6)}-${key.slice(6, 8)}`;

const when = (iso: string | null): string =>
    iso ? new Date(iso).toLocaleString("en-US", { dateStyle: "medium", timeStyle: "short" }) : "-";

const RunsTable: React.FC<RunsTableProps> = ({ runs, loading }) => (
    <Card>
        <CardHeader className="pb-2">
            <CardTitle className="text-left">Recent runs</CardTitle>
            <p className="text-sm text-gray-500">One row per send day. Sent means the email was handed to the mail service.</p>
        </CardHeader>
        <CardContent className="pt-0">
            {loading ? (
                <div className="py-6"><Spinner loadingMessage="Loading runs..." /></div>
            ) : runs.length === 0 ? (
                <p className="py-4 text-sm text-gray-500">No runs yet. The first one appears after the next send day.</p>
            ) : (
                <div className="overflow-x-auto">
                    <Table>
                        <TableHeader>
                            <TableRow>
                                <TableHead>Send day</TableHead>
                                <TableHead>Queued</TableHead>
                                <TableHead>Sent</TableHead>
                                <TableHead>Skipped</TableHead>
                                <TableHead>Failed</TableHead>
                                <TableHead>Last sent at</TableHead>
                            </TableRow>
                        </TableHeader>
                        <TableBody>
                            {runs.map((run) => (
                                <TableRow key={run.periodKey}>
                                    <TableCell className="font-semibold text-primary">{periodLabel(run.periodKey)}</TableCell>
                                    <TableCell>{run.queued + run.sending}</TableCell>
                                    <TableCell>{run.sent}</TableCell>
                                    <TableCell>{run.skipped}</TableCell>
                                    <TableCell className={run.failed > 0 ? "text-red-500 font-semibold" : ""}>{run.failed}</TableCell>
                                    <TableCell>{when(run.lastSentAt)}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </div>
            )}
        </CardContent>
    </Card>
);

export default RunsTable;
